var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","flat":"","clipped-left":""}},[_c('router-link',{attrs:{"to":"/"}},[_c('v-img',{staticClass:"mx-2",attrs:{"src":_vm.app_logo,"max-height":"40","max-width":"40","contain":""}})],1),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.app_name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }